import React from 'react';
import PropTypes from 'prop-types';
import { HorseLink } from '../../../shared/links/ProfileLink';

const HorseCell = ({
    horseName,
    horseUid,
    horseSexCode,
    countryOriginCode,
    damSireStyleName,
    damSireUid,
    damSireCountryOriginCode,
}) => (
    <div>
        <HorseLink
            className={
                (horseSexCode === 'M' || horseSexCode === 'F') ?
                    'hp-sire-progeny__female' :
                    ''
            }
            horseStyleName={horseName}
            horseUid={horseUid}
        />
        <span className="hp-sire-progeny__country"> ({countryOriginCode})</span>
        <div className="hidden-md-up">
            <HorseLink
                className="ui-link_marked"
                horseStyleName={damSireStyleName}
                horseUid={damSireUid}
            />
            <span> ({damSireCountryOriginCode})</span>
        </div>
    </div>
);

HorseCell.propTypes = {
    horseName: PropTypes.string,
    horseUid: PropTypes.number,
    horseSexCode: PropTypes.string,
    countryOriginCode: PropTypes.string,
    damSireStyleName: PropTypes.string,
    damSireUid: PropTypes.number,
    damSireCountryOriginCode: PropTypes.string,
};

export default HorseCell;



// WEBPACK FOOTER //
// ./src/js/horse/progeny/components/HorseCell.jsx